export const itemHeaderReply = "cNa";
export default {itemHeaderReply};